import { render, staticRenderFns } from "./AirLogistic.vue?vue&type=template&id=6927cc75&"
import script from "./AirLogistic.vue?vue&type=script&lang=js&"
export * from "./AirLogistic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports